export default __webpack_public_path__ + "static/media/iconSpin.a26140cc.png";